import { Button, Typography, Box } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

type TAuthFooter = {
  title: string;
  buttonText: string;
  buttonUrl: string;
};

type TProps = {
  children: React.ReactNode;
  footer?: TAuthFooter;
};

export const AuthTemplate = ({ children, footer }: TProps) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={[
        {
          width: '100%',
          maxWidth: '380px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        },
        (theme) => ({
          [theme.breakpoints.up('sm')]: {
            backgroundColor: '#FFFFFF',
            border: '1px solid #E3E7E3',
            borderRadius: '12px',
            boxShadow: '0 2px 12px rgba(10, 30, 11, 0.06)',
            p: '32px',
          },
        }),
      ]}
    >
      {children}

      {footer ? (
        <Box sx={{
          borderTop: '1px solid #DDDFDD',
          mt: '28px',
          pt: '24px',
          maxWidth: '315px',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          <Typography
            sx={{
              mb: '14px',
              fontSize: '16px',
              lineHeight: '22px',
              fontWeight: 600,
              color: '#0A1E0B',
            }}
            variant="body1">
            {footer.title}
          </Typography>
          <Button
            fullWidth
            variant="contained"
            onClick={() => navigate(footer.buttonUrl)}
            sx={{
              py: '12px',
              fontSize: '18px',
              lineHeight: '24px',
              fontWeight: 600,
              textTransform: 'none',
              borderRadius: '12px',
              backgroundColor: '#A1CD3A',
              color: '#0A1E0B',
              '&:hover': {
                backgroundColor: '#8FBA2C',
              },
            }}>
            {footer.buttonText}
          </Button >
        </Box >
      ) : null}
    </Box>
  );
};
